/**
 * Checks for "mouseenter" and "mouseleave" events on ".js-over-out"
 * selector and adds "out" or "over" css classes. Behavior is also aware of
 * css class "active" as one of three states (over, out and active).
 */
(function($){
    var selector = '.js-over-out';
    if (!$(selector).length) return;
    $(document).on('mouseenter mouseleave', selector, function(e){
        if ('mouseenter' == e.type) $(this).removeClass('out').addClass('over');
        else $(this).removeClass('over').addClass('out');
        if ($(this).hasClass('active')) $(this).removeClass('out');
    });
    // add initial state
    $(selector).trigger('mouseleave');
})(jQuery);
